import type { VideoConfigMap } from '../types/video';

class VideoConfigService {
  private configCache: VideoConfigMap | null = null;

  public async getVideoConfig(): Promise<VideoConfigMap> {
    // Check cache first
    if (this.configCache) {
      return this.configCache;
    }

    try {
      const response = await fetch('/assets/config.json');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const config = await response.json();
      
      if (!config) {
        throw new Error('Video configuration not found');
      }

      // Cache the result
      this.configCache = config;
      return config;
    } catch (error: unknown) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
      throw new Error(`Failed to fetch video configuration: ${errorMessage}`);
    }
  }

  public clearCache(): void {
    this.configCache = null;
  }
}

// Export a single configured instance
export const videoConfigService = new VideoConfigService(); 